export const ItemSkeletonComponent = {
  templateUrl: 'components/Skeletons/item-skeleton/item-skeleton.html',
};
